const header = document.getElementById("header");
const logo = document.getElementById("logo");

// Get the offset position of the header
const offset = header.offsetTop;

// Add the sticky class to the header when you reach its scroll position
// Remove it when you leave the scroll position
function toggleSticky() {
  if (window.pageYOffset > offset) {
    header.classList.add("header--sticky");
    logo.classList.add("logo--sticky");
  } else {
    header.classList.remove("header--sticky");
    logo.classList.remove("logo--sticky");
  }
}

// Execute the function when the user scrolls the page
window.onscroll = function () {
  toggleSticky();
};
